import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKassel() {
  return (
    <CityPageTemplate
      city="Kassel"
      slug="kassel"
      intro="Kassel als Documenta-Stadt verbindet Kunst und Innovation – Deine Finanzplanung sollte genauso vorausschauend sein."
      description="Unabhängige & digitale Finanzberatung für Kassel: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
